<div class="nuevo-catalogo-container">
  <p class="heading-catalogo">Empresa</p>
  <button
    (click)="nuevaEmpresa()"
    mat-mini-fab
    aria-label="Agregar nuevo tipo"
    color="primary">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div *ngIf="admonCatEmpresaStatus$ | async as empresaStatus">
  <mat-card-content
    class="nuevo-catalogo-card"
    *ngIf="empresaStatus.mostrarNuevo">
    <mat-card>
      <mat-card-header>
        <form [formGroup]="nuevoRegistro" class="w-full">
          <h3 class="heading-3">Añadir empresa</h3>
          <mat-form-field class="nuevo-catalogo-field">
            <mat-label>Descripción</mat-label>
            <input
              required
              formControlName="descripcion"
              name="descripcion"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              placeholder=""
              (input)="existeRegistro(nuevoRegistro.get('descripcion'), '')" />
            <mat-hint align="end"
              >{{ nuevoRegistro.get("descripcion")?.value.length }} /
              50</mat-hint
            >
            @if ( nuevoRegistro.get('descripcion')?.touched && nuevoRegistro
            .get('descripcion')?.hasError('campoRequerido')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if ( nuevoRegistro.get('descripcion')?.touched &&
            nuevoRegistro.get('descripcion')?.hasError('descripcionCatalogo')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            } @if ( nuevoRegistro.get('descripcion')?.touched &&
            nuevoRegistro.get('descripcion')?.hasError('descripcionDuplicad@'))
            {
            <mat-error> La descripción ya se encuentra registrada. </mat-error>
            }
          </mat-form-field>
        </form>
      </mat-card-header>
      <mat-card-actions align="end" class="nuevo-catalogo-actions">
        <button class="!uppercase" mat-stroked-button (click)="cancelar()">
          Cancelar
        </button>
        <button
          class="!uppercase"
          color="primary"
          mat-flat-button
          [disabled]="nuevoRegistro.invalid || existe"
          (click)="guardarRegistro()">
          Guardar
        </button>
      </mat-card-actions>
    </mat-card>
  </mat-card-content>
</div>
